import React, { useEffect, useState } from 'react'
import TopLevelNav from '../../components/TopLevelNav'
import PageToolbar from '../../components/PageToolbar'
import { EgrantingProcess, EgrantingNanme, LandingBG } from '../../components/SvgIcons'
import { useHistory } from 'react-router-dom'
import LogoGif from './LogoGif'
import './styles.less'
import { Col, Row } from 'rsuite'
import ProjectVersion from '../../widgets/cookie/ProjectVersion'
import { validateLogined } from '../../utils/userClassificationUtil'
import pathname from '../../constants/pathname'

export default function Landing() {
  const [isLogin, setIsLogin] = useState(false)

  let history = useHistory()
  //let code = userClassification()
  if (validateLogined()) {
    // let redirectUrl = `/dashboard?${code}`
    let redirectUrl = pathname.dashboardRoot //`/dashboard`

    let code = localStorage.getItem('thp_user_code')
    if (code == 'THP-Auditor' || code == 'THP-ExternalAuditor') {
      redirectUrl = pathname.audit.AuditReportSummary
    }

    history.push(redirectUrl)
  }

  useEffect(() => {
    setIsLogin(sessionStorage.getItem('openLogin'))
  }, [])

  return (
    <>
      <TopLevelNav setIsLogin={setIsLogin} />
      <PageToolbar isLogin={isLogin} setIsLogin={setIsLogin} />
      <div
        className="loading_bg"
        style={{
          backgroundImage: `url(${LandingBG})`,
        }}
      >
        <Row>
          <Col
            lg={24}
            md={24}
            sm={24}
            xs={24}
            align="left"
            style={{ padding: '30px 20px 0px 20px' }}
          >
            <img src={EgrantingNanme} className="tile_img"></img>
          </Col>
        </Row>
        <Row align="middle">
          <Col lg={18} md={18} sm={24} xs={24} align="center" className="main_img">
            <img src={EgrantingProcess} style={{ width: '100%', height: 'auto' }}></img>
            {/* <img src={EgrantingInfo} style={{ width: '50%', height: 'auto' }}></img> */}
          </Col>
          <Col lg={6} md={6} sm={24} xs={24} align="center" className="logo_gif">
            <LogoGif />
          </Col>
        </Row>
        <ProjectVersion />
      </div>
    </>
  )
}
